import EventTrackingNonDirectLeadsMixin from './eventTrackingNonDirectLeadsMixin';
import EventTrackingRealTimeEventsMixin from './eventTrackingRealTimeEventsMixin';
import EventTrackingTdvEventsMixin from './eventTrackingTdvEventsMixin';
import EventTrackingTdvMetricsMixin from './eventTrackingTdvMetricsMixin';

/* Creates a new instance of a Brochure Tracking Event to track users events when the user submits a lead.
 this class contains all the events that needs be to be done.
*/
export default class BrochureTrackingEvents {
  constructor(model) {
    const data = { ...model, eventLabel: 'Search-CTA-Free-Brochure' };
    this.events = {};
    this.events.googleAnalytics = [
      new EventTrackingTdvEventsMixin(data),
      new EventTrackingTdvMetricsMixin(data),
      new EventTrackingRealTimeEventsMixin(data),
    ];

    /* This "condition" is where we take control of the new Event, without it, this is always fired.
    So, if the "include communities" checkbox is checked, push the instance into the googleAnalytics 
    array and the event is fired. Otherwise, the event is omitted */
    if (data.includeRecommendations === 'True') {
      this.events.googleAnalytics.push(
        new EventTrackingNonDirectLeadsMixin(data)
      );
    }
  }
}
